import React, { useEffect, useState } from 'react';
import { StyleSheet, Text, View } from 'react-native';
import Colors from '../../../assets/Color/Colors';
import { globalFontStyle, globalStyle } from '../../../assets';
import FormTextLabel from '../../../commonComponents/FormTextLabel';
import { globalConfigurableData } from '../../../utils/globalConstant';

export const HeaderOptionsTab = ({
  _eventInfo,
  setHeaderOptions,
  headerOptions,
  eventDetails,
  chartCount,
}) => {
  const [headerOptionsMap, setHeaderOptionMap] = useState([]);

  useEffect(() => {
    if (
      eventDetails &&
      _eventInfo &&
      eventDetails?.eventId === _eventInfo?.id
    ) {
      const data = [];
      if (eventDetails?.liveCard) {
        data.push({ title: 'Stats', action: 'livestats' });
      }
      if (_eventInfo?.widget_url) {
        data.push({ title: 'Stats', action: 'tradingview' });
      }
      if (!eventDetails?.liveCard && eventDetails?.liveView) {
        data.push({ title: 'Live Stream', action: 'liveStream' });
      }
      // if (eventDetails?.invested_amount) {
      //   data.push({ title: "Investments", action: "myinvestments" });
      // }
      if (
        eventDetails?.timeSeriesData &&
        eventDetails?.timeSeriesData?.length > (chartCount || 19)
      ) {
        data.push({ title: 'Yes Chart', action: 'graph' });
      }
      data.push({ title: 'About', action: 'about' });

      setHeaderOptionMap(data);
      if (data.length > 0) {
        setHeaderOptions(data[0].action);
      } else {
        setHeaderOptions('');
      }
    }
  }, [_eventInfo?.is_price_editable, eventDetails?.eventId]);

  const onHeaderOptionsClick = value => {
    setHeaderOptions(value);
  };

  return (
    <>
      {headerOptionsMap.length !== 0 ? (
        <View style={styles.headerOptionsRow}>
          {headerOptionsMap.map((item, i) => {
            return (
              <FormTextLabel
                key={i}
                onPress={() => onHeaderOptionsClick(item?.action)}
                labelStyles={
                  headerOptions === item?.action
                    ? styles.headerOptionsSelected
                    : styles.headerOptions
                }
                label={item?.title}
              />
            );
          })}
        </View>
      ) : null}
    </>
  );
};

export default HeaderOptionsTab;

const styles = StyleSheet.create({
  headerOptionsRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
    backgroundColor: 'transparent',
    paddingVertical: 0,
    paddingHorizontal: 0,
  },
  headerOptions: {
    ...globalFontStyle.appFontHeadingRegular,
    color: Colors.grey,
    paddingVertical: 8,
    paddingHorizontal: 16,
    textAlign: 'center',
    marginRight: 24,
  },
  headerOptionsSelected: {
    ...globalFontStyle.appFontHeading,
    color: Colors.black,
    paddingVertical: 8,
    paddingHorizontal: 16,
    textAlign: 'center',
    marginRight: 24,
    borderBottomWidth: 2,
    borderBottomColor: Colors.black,
    backgroundColor: 'transparent',
  },
});
